import React from "react";
import { Switch, Route } from "react-router-dom";
import styled from "styled-components";

import AppRoute from "./common/components/AppRoute";
import { Loader } from "./common/components/core";
import { useAuthRehydrate } from "./common/hooks";
import ArchitectView from "./features/architect/ArchitectView";
import InvoiceDownloadView from "./features/bank/InvoiceDownloadView";
import BusinessRoutes from "./features/BusinessRoutes";
import PublicRoutes from "./features/PublicRoutes";
import PlatformAgreementView from "./features/public/PlatformAgreementView";

const App = (): JSX.Element => {
    const isHydrated = useAuthRehydrate();

    return (
        <Container className="d-flex flex-column">
            <Loader isLoading={!isHydrated}>
                <Switch>
                    <AppRoute path="/login" component={PublicRoutes} />
                    <AppRoute
                        path="/forgot-password"
                        component={PublicRoutes}
                    />
                    <AppRoute path="/reset-password" component={PublicRoutes} />
                    <AppRoute path="/reset-2fa" component={PublicRoutes} />
                    <AppRoute path="/create-account" component={PublicRoutes} />
                    <AppRoute
                        path="/architect/claim/:linearId"
                        component={ArchitectView}
                    />
                    <AppRoute
                        path="/bank/payment/:projectId/:invoiceId/:paymentId"
                        component={InvoiceDownloadView}
                    />
                    <Route
                        path="/platform-agreement"
                        component={PlatformAgreementView}
                    />
                    <AppRoute auth path="/" component={BusinessRoutes} />
                </Switch>
            </Loader>
        </Container>
    );
};

const Container = styled.div`
    min-height: 100vh;
`;

export default App;
